import './vendor';
import {Swiper, Navigation, Pagination} from './vendor';
import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

function addCustomSelect() {
	let data = [
		{ id: 'event1', text: 'Аналитика и визуализация метрик SOC: ключевые показатели функционирования SOC на различных уровнях управления (от стратегического до оперативного). Оценка эффективности процессов SOC.'},
		{ id: 'event2', text: 'Предотвращение реальных внешних цифровых угроз: непубличные кейсы Solar AURA.'},
		{ id: 'event3', text: 'Как усилить систему информационной безопасности с помощью нового решения Solar Data Access Governance (DAG)?'},
		{ id: 'event4', text: 'Solar NGFW – полгода. Ключевые результаты проведенных пилотов и новые подходы к решению задач клиентов. Презентация программно-аппаратного комплекса Solar NGFW.'},
		{ id: 'event5', text: 'Закрытая презентация новой комплексной программы развития навыков кибербезопасности "Солар КиберБуст".'},
		{ id: 'event6', text: 'Новые функции и возможности платформы "Солар Кибермир" для эффективной отработки практических навыков по кибербезопасности.'},
	]

	$('#select-event').select2({
		data: data,
		dropdownParent: '.custom-select_event',
		tags: true,
	}).on('change', function() {
		$(this).addClass('label-top');
		// $(this).valid();
	});

}

function animationToBlock() {
	const scrollButtons = document.querySelectorAll('.js-go-to-registration');

	scrollButtons.forEach((button) => {
		button.addEventListener('click', () => {
			const targetId = button.getAttribute('data-target');
			const targetBlock = document.getElementById(targetId);

			targetBlock.scrollIntoView({
				behavior: 'smooth',
				block: 'start',
			});
		});
	});
}

function addClassForInput() {
	const inputs = document.querySelectorAll('.form__input');

	function checkValue(element) {
		if (element.value !== '') {
			element.classList.add('form__input_not-empty');
		} else {
			element.classList.remove('form__input_not-empty');
		}
	}

	for (let element of inputs) {
		checkValue(element);

		element.addEventListener('change', () => {
			checkValue(element);
		});
	}
}

function addedMaskPhone() {
	$('.js-phone-input').mask('+7 (000) 000-00-00');
}

function validationForm() {
	const form = $('.js-form-registration');

	form.validate({
		rules: {
			user_phone: {
				minlength: 18,
			},
		},
		messages: {
			user_phone: {
				minlength: 'Введите корректный номер телефона',
			},
			user_mail: {
				email: 'Введите корректный email',
			},
		},
		// eslint-disable-next-line no-shadow
		submitHandler: (form) => {
			const formData = $(form).serialize();

			$.ajax({
				type: 'POST',
				url: '',
				data: formData,
				success: (data) => {
					let result = JSON.parse(data);

					if (result.result !== 'error') {
						const successBlock = document.querySelector('.success');
						$(form).find('.form__input').val('').removeClass('form__input_not-empty valid');
						$('.registration__title').hide();
						$(form).hide();
						$('.success').show();

						successBlock.scrollIntoView({
							behavior: 'smooth',
							block: 'start',
						});
					} else if (result.code === 'email') {
						// eslint-disable-next-line no-console
						console.log('ошибка отправки');
						// eslint-disable-next-line no-alert
						alert('Произошла ошибка при отправке данных');
					}
				},
				error: (error) => {
					// eslint-disable-next-line no-console
					console.error('Произошла ошибка при отправке данных: ', error);
					// eslint-disable-next-line no-alert
					alert('Произошла ошибка при отправке данных');
				},
			});
		},
	});

	$.extend($.validator.messages, {
		required: 'Это поле обязательно для заполнения',
	});
}

function initAnimationBlock() {
	const controller = new ScrollMagic.Controller();
	const blocksAnimation = document.querySelectorAll('.section-animation');

	blocksAnimation.forEach((block, item) => {
		const triggerElement = document.querySelector('.registration');
		const stylesElement = window.getComputedStyle(triggerElement);
		const paddingTopValue = parseInt(stylesElement.paddingTop, 10);

		let offsetTrigger = item === 2 ? -paddingTopValue : 0;

		// eslint-disable-next-line no-unused-vars
		const scene = new ScrollMagic.Scene({
			reverse: true,
			triggerElement: block,
			triggerHook: 0.83,
			offset: offsetTrigger,
		})
			.setClassToggle(block, 'section-animation_active')
			.addTo(controller);
			// .addIndicators();
	});
}

addClassForInput();
animationToBlock();
addedMaskPhone();
validationForm();
// addCustomSelect();
